import { useState, type FormEvent } from "react";

import { ErroAPI, api } from "../api.ts";
import { useSessao } from "../sessao.tsx";

export function TrocarSenha() {
  const { recarregar, sair } = useSessao();
  const [nova, setNova] = useState("");
  const [confirma, setConfirma] = useState("");
  const [erro, setErro] = useState("");

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro("");
    try {
      await api.post("/trocar-senha", { nova, confirma });
      await recarregar();
    } catch (err) {
      setErro(err instanceof ErroAPI ? err.message : "Nao consegui trocar a senha.");
    }
  }

  return (
    <div className="login">
      <form className="login__caixa" onSubmit={enviar}>
        <img src="/logo-conceitto.webp" alt="Conceitto" className="login__logo" />
        <p className="login__titulo">Escolha uma senha nova para continuar</p>
        {erro && <div className="alerta alerta--erro">{erro}</div>}
        <label className="campo">
          <span className="campo__rotulo">Senha nova</span>
          <input type="password" value={nova} autoComplete="new-password" required autoFocus
                 onChange={(e) => setNova(e.target.value)} />
          <span className="campo__dica">
            Pelo menos 10 caracteres. Uma frase funciona melhor que um amontoado de simbolos.
          </span>
        </label>
        <label className="campo">
          <span className="campo__rotulo">Repita a senha</span>
          <input type="password" value={confirma} autoComplete="new-password" required
                 onChange={(e) => setConfirma(e.target.value)} />
        </label>
        <button className="botao" type="submit">Salvar</button>
        <button className="botao botao--fantasma botao--pequeno mt-lg" type="button"
                onClick={() => void sair()}>Sair</button>
      </form>
    </div>
  );
}
